import React from 'react'
import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation()

    const toggleLanguage = () => {
        const next = i18n.language === 'zh' ? 'en' : 'zh'
        i18n.changeLanguage(next)
    }

    const label = i18n.language === 'zh' ? t('language.en') : t('language.zh')

    return (
        <button
            onClick={toggleLanguage}
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
            <Globe className="h-4 w-4" />
            {label}
        </button>
    )
}

export default LanguageSwitcher
